import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { apiUrl } from '../utils/apiBase';

const AuthTestPage = () => {
  const { user, isAuthenticated, token } = useAuth();
  const [localToken, setLocalToken] = useState(null);
  const [userFromAPI, setUserFromAPI] = useState(null);

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    setLocalToken(storedToken);
    
    if (storedToken) {
      // Test API call
      fetch(apiUrl('/auth/me'), {
        headers: {
          'Authorization': `Bearer ${storedToken}`,
          'Accept': 'application/json',
        },
      })
      .then(response => response.json())
      .then(data => {
        console.log('API response:', data);
        setUserFromAPI(data.data);
      })
      .catch(error => {
        console.error('API error:', error);
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Auth Test Page</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-semibold mb-4">AuthContext State</h2>
            <div className="space-y-2">
              <p><strong>isAuthenticated:</strong> {isAuthenticated ? 'true' : 'false'}</p>
              <p><strong>token:</strong> {token ? 'Present' : 'Missing'}</p>
              <p><strong>user:</strong> {user ? JSON.stringify(user, null, 2) : 'null'}</p>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-semibold mb-4">LocalStorage & API</h2>
            <div className="space-y-2">
              <p><strong>localStorage token:</strong> {localToken ? 'Present' : 'Missing'}</p>
              <p><strong>API user:</strong> {userFromAPI ? JSON.stringify(userFromAPI, null, 2) : 'Not fetched'}</p>
            </div>
          </div>
        </div>

        <div className="mt-8 bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Actions</h2>
          <div className="space-x-4">
            <button
              onClick={() => {
                localStorage.removeItem('token');
                window.location.reload();
              }}
              className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700"
            >
              Clear Token & Reload
            </button>
            <button
              onClick={() => {
                window.location.href = '/simple-login';
              }}
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
            >
              Go to Simple Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthTestPage;



